import { ScholarshipCard } from '@common-types';

import { UsheIcon } from '@components/UsheIcon';

import LocationIcon from '@images/location.svg?react';

import { StyledUtahBadge, StyledUtahBadgeLabel, StyledLocationIcon } from './UtahBadge.styles';

export type UtahBadgeVariant = NonNullable<ScholarshipCard['utahBadge']>;

const UTAH_BADGE_LABELS: Record<UtahBadgeVariant, string> = {
  ushe: 'Utah public college',
  utah: 'Utah',
};

interface UtahBadgeProps {
  variant: UtahBadgeVariant;
}

export const UtahBadge = ({ variant }: UtahBadgeProps) => (
  <StyledUtahBadge>
    {variant === 'ushe' ? (
      <UsheIcon />
    ) : (
      <StyledLocationIcon aria-hidden="true">
        <LocationIcon />
      </StyledLocationIcon>
    )}

    <StyledUtahBadgeLabel>{UTAH_BADGE_LABELS[variant]}</StyledUtahBadgeLabel>
  </StyledUtahBadge>
);
